import { Col } from 'components/Col';
import { CustomCheckbox } from 'components/CustomCheckbox';
import { Row } from 'components/Row';
import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { ChangeEvent, useContext } from 'react';
import languageValues from 'utils/LanguageUtils';

export default function ConsultaPublica() {
  const { state, dispatch } = useContext(ProjetosContext);
  return (
    <Row>
      <Col>
        <CustomCheckbox
          name='consultaPublica'
          label={languageValues.inputs.consultaPublica.label}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            dispatch({
              type: 'setProjeto',
              payload: { consultaPublica: event.target.checked },
            });
          }}
          disabled={!state.projeto.direitoImagem || state.disabledFields}
          checked={state.projeto.consultaPublica || false}
        />
      </Col>
    </Row>
  );
}
